import { useCallback } from 'react'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { LANGUAGE_FROM_TOLGEE } from 'consts/languageFromTolgee'
import type { InsightsLanguages } from 'generated/graphql'
import { useDashboardMutations } from 'hooks-queries/dashboards'
import { useCurrentLanguage, useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import { CREATE_DASHBOARD_CSV_EXPORT_LOG } from './export-csv-button.consts'
import type { IExportCsvButton, IExportCsvButtonViewProps } from './export-csv-button.types'

export const useExportCsvButtonModel = ({ folderId, jobId, type }: IExportCsvButton): IExportCsvButtonViewProps => {
  const language = useCurrentLanguage()
  const { createToast } = useToast()
  const t = useTranslate()

  const [createJobCSVExport, { loading: mutationLoading }] = useDashboardMutations({
    errorLog: CREATE_DASHBOARD_CSV_EXPORT_LOG,
    mutationName: 'createJobCSVExport',
  })

  const handleCSVExport = useCallback(() => {
    const currentLanguage = LANGUAGE_FROM_TOLGEE[language] as InsightsLanguages

    const { EXPORT_DASHBOARD_CSV } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(EXPORT_DASHBOARD_CSV, {
      jobId,
      folderId,
      type,
      language,
    })

    createJobCSVExport({
      variables: {
        input: {
          jobId,
          language: currentLanguage,
          type,
          ...(folderId !== 'allReferences' && { folderId }),
        },
      },
    })
      .then(({ data }) => {
        if (data.createExportCsv.success) {
          createToast({
            content: t(TOLGEE_GLOBALS.csvEmail),
          })
          return
        }
        createToast({
          content: t(TOLGEE_GLOBALS.somethingWentWrong),
        })
      })
      .catch(() => {
        createToast({
          content: t(TOLGEE_GLOBALS.somethingWentWrong),
        })
      })
  }, [language, createJobCSVExport, jobId, type, folderId, createToast, t])

  return {
    handleCSVExport,
    mutationLoading,
  }
}
